// Bootstrap scripts


removeClass(document.documentElement, 'no-js');

$(function () {
    window.scrollBarWidth = getScrollbarWidth();
    $(window).on('resize', () => {
        window.scrollBarWidth = getScrollbarWidth();
    });

    $(document).on('click', '.teamtailor-jobs__job', (e) => {
        const url = $(e.currentTarget).find('a').attr('href');
        window.open(url, '_blank');
        e.preventDefault();
    });

    // object fit polyfill
    objectFitImages();

    Home.init();
    WorkIndex.init();
    TalentIndex.init();
    MasonryBlocks.init();
    LookingFor.init();

    // These should be initialised ad-hoc
    Navigation.init();
    Clock.init();
    Slides.init();
    ToggleClass.init();
    Newsletter.init();
    ThumbAnim.init();
    ThumbSlideshow.init();
    ImageGrid.init();

    new Search();

    // Show breakpoint debug on localhost
    if (window.location.host.match(/localhost|nikko.local|duderino.local/i)) {
        $('#mq').css({display: 'block'});
    }
});


function removeClass (el, className) {
    if (el.classList) {
        el.classList.remove(className);
    } else {
        el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    }
}

function getScrollbarWidth () {
    var outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.width = '100px';
    document.body.appendChild(outer);

    var widthNoScroll = outer.offsetWidth;
    // force scrollbars
    outer.style.overflow = 'scroll';

    // add innerdiv
    var inner = document.createElement('div');
    inner.style.width = '100%';
    outer.appendChild(inner);

    var widthWithScroll = inner.offsetWidth;

    // remove divs
    outer.parentNode.removeChild(outer);

    return widthNoScroll - widthWithScroll;
}
